"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _StylesProvider = _interopRequireDefault(require("./StylesProvider"));

var _Baseline = _interopRequireDefault(require("./Baseline"));

/**
 * Provides an application with a defined material theme
 * and establishes baseline CSS styling.
 */
var ThemeProvider = function ThemeProvider(_ref) {
  var theme = _ref.theme,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_StylesProvider["default"], null, /*#__PURE__*/_react["default"].createElement(_styles.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_Baseline["default"], null), children));
};

ThemeProvider.propTypes = {
  theme: _propTypes["default"].object.isRequired,
  children: _propTypes["default"].node.isRequired
};
var _default = ThemeProvider;
exports["default"] = _default;